import React, { useMemo } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { useWrhDays } from '../../wrh/useData';
import { StatCounterGrid, type StatCounterItem } from './shared';

const WrhComplianceCounters: React.FC<{ embedded?: boolean; settings?: Record<string, unknown> }> = ({
  embedded,
}) => {
  const { colors } = useTheme();
  const { data, isLoading } = useWrhDays(undefined, 1, 200);

  const counters: StatCounterItem[] = useMemo(() => {
    let open = 0;
    let closed = 0;
    let withNc = 0;
    for (const day of data ?? []) {
      if (day.status === 'OPEN') open += 1;
      else if (day.status === 'CLOSED') closed += 1;
      if ((day.ncCount ?? 0) > 0) withNc += 1;
    }
    return [
      {
        key: 'open',
        label: 'Open days',
        value: open,
        href: '/wrh',
        accent: colors.primary,
      },
      {
        key: 'closed',
        label: 'Closed days',
        value: closed,
        href: '/wrh',
        accent: 'bg-emerald-500',
      },
      {
        key: 'nc',
        label: 'With NC',
        value: withNc,
        href: '/wrh/compliance',
        accent: 'bg-rose-500',
      },
    ];
  }, [colors.primary, data]);

  return (
    <StatCounterGrid
      title="WRH · Compliance"
      counters={counters}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/wrh/compliance"
    />
  );
};

export default WrhComplianceCounters;
